/** Hostnames de producción — mismo deploy Vercel, routing por subdominio. */
export const CLINICAL_HOSTS = [
  'clinical.concienciasanate.com',
  'clinical.local.concienciasanate.com',
  'concienciasanate.com',
  'www.concienciasanate.com',
  'app.concienciasanate.com',
  'app.local.concienciasanate.com',
] as const;

export const CARE_HOSTS = ['care.concienciasanate.com', 'care.local.concienciasanate.com'] as const;

/** Prefijo estático del export Expo Care dentro de `dist/` (no aparece en URLs públicas del subdominio). */
export const CARE_STATIC_PREFIX = '/care-static';

export type HostAppId = 'clinical' | 'care';

export type HostBranding = {
  appId: HostAppId;
  title: string;
  description: string;
  themeColor: string;
};

export const HOST_BRANDING: Record<HostAppId, HostBranding> = {
  clinical: {
    appId: 'clinical',
    title: 'Elynthis Clinical',
    description:
      'Software clínico para profesionales de la salud: pacientes, historia clínica, agenda, documentos, facturación y RIPS.',
    themeColor: '#1e4d3a',
  },
  care: {
    appId: 'care',
    title: 'Elynthis Care',
    description:
      'Acompañamiento y seguimiento del paciente con su equipo de salud mental. Sin acceso a módulos clínicos ni facturación.',
    themeColor: '#2d6a4f',
  },
};
